import { DEFAULT_LOCALE, LOCALES, type CommonResource, type Locale } from '@pickpro/i18n';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

const loaders = import.meta.glob<CommonResource>(
  '../../../../../packages/i18n/src/locales/*/common.json',
  { import: 'default' },
);

async function loadCommon(locale: string): Promise<CommonResource> {
  const loader = loaders[`../../../../../packages/i18n/src/locales/${locale}/common.json`];
  if (!loader) throw new Error(`no resources for locale ${locale}`);
  return loader();
}

export const i18n = i18next.createInstance();

export async function initI18n(locale: Locale): Promise<void> {
  const common = await loadCommon(locale);
  await i18n.use(initReactI18next).init({
    lng: locale,
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: [...LOCALES],
    ns: ['common'],
    defaultNS: 'common',
    resources: { [locale]: { common } },
    interpolation: { escapeValue: false },
  });
}

export async function changeLocale(locale: Locale): Promise<void> {
  if (!i18n.hasResourceBundle(locale, 'common')) {
    i18n.addResourceBundle(locale, 'common', await loadCommon(locale));
  }
  await i18n.changeLanguage(locale);
}
